import React from 'react';
import { bookingStatus } from '../../ui';
import JobList from '../Audits/JobList';

const Bookings = () => (
  <JobList
    title="Bookings"
    subtitle="Jobs created from accepted quotes, through to completion."
    endpoint="/booking/all_bookings"
    idKey="booking_id"
    statusOf={bookingStatus}
    detailPath="/bookings/manage-booking"
    groups={[['Needs a vendor', [0]], ['In progress', [1, 2, 3]], ['Complete', [4, 5]], ['Cancelled', [-1, -2]]]}
    dateLabel="Job date"
  />
);

export default Bookings;
